export default __webpack_public_path__ + "alberta-comment.4ef2b1ae5b1368ce3920.svg";